<template>
    <div>
        <header>
            <nav class="navbar navbar-expand-sm navbar-dark bg-dark fixed-top" style="
            margin-bottom: 0;
            margin-top: 0;
            padding-bottom: 1px;
            padding-top: 1px;">
                <!-- <button class="navbar-toggler" type="button" style="font-size: 16px;padding: 9px;" onclick="w3_open()">
                    <span>
                        <i class="fas fa-align-justify" style="color: white;"></i>
                    </span>
                </button> -->
                <a href="#" class="navbar-brand" style="font-size: 15px;color: white;">
                    <img src="../assets/logo.png" class="d-inline-block align-top" style="width: 20px;margin-right: 10px;">
                            Anaj
                </a>
                <!-- <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation" style="font-size: 16px;padding: 9px;">
                    <span>
                        <i class="fa fa-bars" style="color: white;"></i>
                    </span>
                </button> -->
                <div class="navbar-collapse collapse" id="navbarTogglerDemo01" style="">
                    <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                        <li class="nav-item">
                         
                           <span title="Role" class = "badge badge-success" style = "margin:10px"> {{$auth.user().role}}</span>
                        </li>
                        <li class="nav-item">
                           <h6 title="User Name" style = "color:white;margin-top:6px"> {{$auth.user().userName}}</h6>
                        </li>
                        <li class="nav-item">
                            <a href="javascript:void(0)" title="Logout"  class="nav-link" @click="$auth.logout()">
                               <i class="fas fa-sign-out-alt" style = "color:white"></i>

                            </a>
                        </li>
                      
                    </ul>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
export default {
  
  name: 'app',
  
    methods:{
      logout(){
      
        this.$auth.lohout()
      }
    }
}
</script>